import { render, staticRenderFns } from "./TemplateEventsStatusPieChart.vue?vue&type=template&id=fdab4cc2&scoped=true&"
import script from "./TemplateEventsStatusPieChart.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsStatusPieChart.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsStatusPieChart.vue?vue&type=style&index=0&id=fdab4cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdab4cc2",
  null
  
)

export default component.exports